import { Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Grid } from '@mui/material';
import { Search, Download, Print } from '@mui/icons-material';
import { libroMayor } from '../billingData';

const GeneralLedger = () => {
  const totalDebe = libroMayor.reduce((acc, doc) => acc + doc.debe, 0);
  const totalHaber = libroMayor.reduce((acc, doc) => acc + doc.haber, 0);
  const totalSaldoFinal = libroMayor.reduce((acc, doc) => acc + doc.saldoFinal, 0);

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Libro Mayor
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Registro por cuenta de los movimientos contables
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar Excel
          </Button>
        </Box>
      </Box>

      {/* Stats */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#e3f2fd' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Débito</Typography>
              <Typography variant="h5" color="primary">${totalDebe.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#e8f5e9' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Crédito</Typography>
              <Typography variant="h5" color="success.main">${totalHaber.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#fff3e0' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Saldos</Typography>
              <Typography variant="h5" color="warning.main">${totalSaldoFinal.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filters */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar cuenta..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Desde"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Hasta"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button variant="outlined" fullWidth>
                Generar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table */}
      <Card>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Cuenta</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Saldo Inicial</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Débito</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Crédito</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Saldo Final</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {libroMayor.map((doc, index) => (
                  <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#fafafa' } }}>
                    <TableCell sx={{ fontWeight: 500 }}>{doc.cuenta}</TableCell>
                    <TableCell align="right">${doc.saldoInicial.toFixed(2)}</TableCell>
                    <TableCell align="right">${doc.debe.toFixed(2)}</TableCell>
                    <TableCell align="right">${doc.haber.toFixed(2)}</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>${doc.saldoFinal.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow sx={{ backgroundColor: '#e3f2fd', fontWeight: 'bold' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>TOTALES</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${libroMayor.reduce((a, d) => a + d.saldoInicial, 0).toFixed(2)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalDebe.toFixed(2)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalHaber.toFixed(2)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalSaldoFinal.toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Libro Mayor
          </Typography>
          <Typography variant="body2">
            El libro mayor es un documento contable que presenta el movimiento y saldo de cada cuenta de manera 
            individual. Se utiliza para elaborar los estados financieros y verificar el equilibrio de la contabilidad.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default GeneralLedger;
